import useMediaQuery from "@mui/material/useMediaQuery";
import { useState } from "react";
import HeroPage from "./HeroPage";
import SurveyQuestions from "./SurveyQuestions";
import SurveyHeader from "./SurveyHeader";
import SurveySideSvg from "../EditableSvgs/SurveySideSvg";
import { FontSource } from "@fhc/shared/constants";

const Survey = ({ themeColors, companyDetails, onFinish, disableStartButton, advisorDirectLink, name, setName }) => {
    const [step, setStep] = useState(0);
    const [start, setStart] = useState(false);

    const mdScreen = useMediaQuery("(min-width: 768px)");
    const lgScreen = useMediaQuery("(min-width: 1000px)");

    const google_fonts_url_base = "https://fonts.googleapis.com/css2?family="

    return (
        <>
            <style>{
`
${themeColors.customHeaderFont.source === FontSource.GOOGLE_FONT ?
`@import url('${google_fonts_url_base}${themeColors.customHeaderFont.name}');` : ''
}
${themeColors.customBodyFont.source === FontSource.GOOGLE_FONT && (themeColors.customHeaderFont.source !== FontSource.GOOGLE_FONT || themeColors.customHeaderFont.name !== themeColors.customBodyFont.name) ? 
`@import url('${google_fonts_url_base}${themeColors.customBodyFont.name}');` : ''
}
${themeColors.customHeaderFont.source === FontSource.FILE ?
`${themeColors.customHeaderFont.file ? 
`@font-face {
    font-family: '${themeColors.customHeaderFont.name}';
    src: url('${themeColors.customHeaderFont.file.data}');
}` : ""
}` : ""
}
${themeColors.customBodyFont.source === FontSource.FILE ?
`${themeColors.customBodyFont.file ?
`@font-face {
    font-family: '${themeColors.customBodyFont.name}';
    src: url('${themeColors.customBodyFont.file.data}');
}` : ""
}` : ""
}
.survey-landing-page-heading {
    font-family: '${themeColors.customHeaderFont.name}', '${themeColors.customHeaderFont.type}';
}
        
.survey-landing-page-text,
.survey-question-text,
.c-box,
.body-text,
.MuiTypography-body1,
.MuiInputBase-root,
.MuiButton-textPrimary {
    font-family: '${themeColors.customBodyFont.name}', '${themeColors.customBodyFont.type}';
}`
}</style>
            {start ? (
                <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    <SurveyHeader themeColors={themeColors} />
                    <div style={{ display: "flex", flexGrow: "1" }}>
                        <div
                            style={{
                                marginLeft: "24px",
                                marginRight: "24px",
                                paddingTop: mdScreen ? "80px" : "50px",
                                paddingBottom: mdScreen ? null : "10px",
                                maxWidth: lgScreen ? "60%" : "100%",
                                width: "100%",
                            }}
                        >
                            <SurveyQuestions
                                activeStep={step}
                                setActiveStep={setStep}
                                themeColors={themeColors}
                                handleGetResult={onFinish}
                                questions={companyDetails.questions.filter((q) => q.type !== "multiple-rating")}
                            />
                        </div>
                        {step !== 2 && lgScreen && (
                            <SurveySideSvg
                                primaryColor={themeColors.primaryColor}
                                secondaryColor={themeColors.secondaryColor}
                                style={{ marginLeft: "auto" }}
                            />
                        )}
                    </div>
                </div>
            ) : (
                <HeroPage
                    themeColors={themeColors}
                    setStart={setStart}
                    disableStartButton={disableStartButton}
                    advisorDirectLink={advisorDirectLink}
                    name={name}
                    setName={setName}
                />
            )}
        </>
    );
};

export default Survey;
